<template>
  <div class="tabs">
    <div class="tabs-nav">
      <div
        ref="tabNav"
        v-for="tab in tabs"
        :key="tab.name"
        class="tabs-nav__item"
        :class="{
          'tabs-nav__item--active': active === tab.name
        }"
        @click="onTabChange(tab)"
      >
        <component
          v-if="tab.titleSlot"
          :is="tab.titleSlot"
        />
        <template v-else>
          {{ tab.title }}
        </template>
      </div>
      <div
        ref="tabLine"
        class="tabs-nav__line"
      />
    </div>
    <div class="tabs-content">
      <slot />
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(['change'])
const active = defineModel('active', { type: [Number, String] })
const tabs = ref([])
const tabNavRefs = useTemplateRef('tabNav')
const tabLineRef = useTemplateRef('tabLine')

const register = (tab) => {
  tabs.value.push(tab)
}

provide('tabs', {
  register,
  active,
  tabs
})

const setLine = () => {
  const activeIndex = tabs.value.findIndex(tab => tab.name === active.value)

  const activeNav = tabNavRefs.value[activeIndex]

  const left = activeNav.offsetLeft + activeNav.offsetWidth / 2

  tabLineRef.value.style.left = `${left}px`
}

const onTabChange = (tab) => {
  active.value = tab.name
  emits('change', tab.name)
}

watch(active, () => {
  setLine()
})

onMounted(() => {
  setLine()
})
</script>

<style lang="less">
.tabs {
  &-nav {
    position: relative;
    display: flex;
    border-bottom: 1px solid #EBF1F5;

    &__item {
      position: relative;
      padding: 0 8px 12px;
      font-family: mon-600;
      font-size: 16px;
      line-height: 20px;
      color: #5C5C5C;
      cursor: pointer;

      &--active {
        font-family: mon-700;
        color: #232323;
      }

      &:first-child {
        padding-left: 0;
      }
      &:nth-last-child(2) {
        padding-right: 0;
      }
    }

    &__line {
      position: absolute;
      bottom: 0;
      transform: translateX(-50%);
      height: 3px;
      width: 80px;
      background-color: #232323;
      border-radius: 4px 4px 0 0;
      transition: all .2s ease-in-out;
    }
  }

  &-content {
    padding: 24px 0;
  }
}
</style>
